import './normalize.css';
require('./../../bower_components/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css');

require('jquery-ui/themes/base/dialog.css');

import './grid.css';
import './structure.css';
import './spacing.css';
import './colors.css';
import './typography.css';
import './alerts.css';
import './buttons.css';
import './labels.css';
import './forms.css';
import './barrating.css';
import './tagify.css';
import './tables.css';
import './modals.css';
import './icons.css';
import './animations.css';
import './schedule.css';
import './style.css';